import styles from './style.module.css';
import NavLink from '@components/Common/NavLink';

import {
  faAddressCard,
  faAngleRight,
  faBookOpen,
  faCommentDots,
  faDownload,
  faStore,
} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useRouter} from 'next/router';
import NavItem from '@components/Common/NavItem';
import Link from '@components/Common/Link';

import {CMS_BASE_URL, REFERENCE_BASE_URL} from '@constants/common';
import {
  AskOfferLinks,
  BuyersGuidsLink,
  ContactInformationLinks,
  DownloadLoadBrochuresLink,
  ProductsLink,
} from '@constants/navigations';
import {useTranslation} from 'next-i18next';
import {LocaleEnum} from '@enums/locale';
import {ComponentWithChildrenProps} from '@interfaces/component';

export interface CMSMenu extends Record<string, any> {
  sub_breadcrumb?: CMSMenu[];
}
interface CMSSideMenuProps extends ComponentWithChildrenProps {
  parentContentId?: number;
  contentId: number;
  showMobileNav: boolean;
  menu: CMSMenu[];
  isReferencePage?: boolean;
}

export default function CMSSideMenu(props: CMSSideMenuProps) {
  const {t} = useTranslation('common');
  const {parentContentId, contentId, menu, showMobileNav, isReferencePage} =
    props;
  const router = useRouter();
  const locale = router.locale as unknown as LocaleEnum;
  const baseURL = isReferencePage
    ? REFERENCE_BASE_URL[locale].link
    : CMS_BASE_URL[locale].link;
  const slashContentId = isReferencePage
    ? `/${router.query.contentContainerId}`
    : '';
  return (
    <div
      className={`${styles.accountSideMenuContainer} ${
        showMobileNav ? styles.showMobileNav : ''
      }`}
    >
      <ul className={styles.accountSideMenu}>
        {menu.map(item => {
          const link_name = item[`link_name_${locale}`];
          const slug = item[`seo_friendly_url_${locale}`];
          const id = isReferencePage ? item.id : item.ContentContainerId;
          if (!link_name) return null;
          return (
            <NavItem
              key={id}
              classNames={`${
                id === parentContentId || id === contentId
                  ? styles.activeLink
                  : ''
              }`}
              locale={locale}
            >
              <Link href={`${baseURL}${slug}${slashContentId}`}>
                <FontAwesomeIcon icon={faAngleRight} />
                <span>{link_name}</span>
              </Link>
              {item.sub_breadcrumb &&
              item.sub_breadcrumb.filter(sub_menu => {
                if (sub_menu[`link_name_${locale}`]) {
                  return sub_menu;
                }
              }).length > 0 ? (
                <ul className={styles.subMenu}>
                  {item.sub_breadcrumb?.map(sub_menu => {
                    const menuId = sub_menu.ContentContainerId;
                    const sub_link_name = sub_menu[`link_name_${locale}`];
                    const sub_link = sub_menu[`seo_friendly_url_${locale}`];
                    if (!sub_link) return null;
                    return (
                      <NavLink
                        href={`${baseURL}${sub_link}${slashContentId}`}
                        key={menuId}
                        classNames={`${
                          menuId === contentId ? styles.activeLink : ''
                        }`}
                      >
                        <FontAwesomeIcon icon={faAngleRight} />
                        <span>{sub_link_name}</span>
                      </NavLink>
                    );
                  })}
                </ul>
              ) : null}
            </NavItem>
          );
        })}
      </ul>
      <h4 className={`${menu.length > 0 ? 'mt-4' : 'mt-0'} `}>
        {t<string>('footer.quick_links.header')}
      </h4>
      <ul className={`${styles.accountSideMenu} ${styles.quickLinks}`}>
        <NavLink
          href={ContactInformationLinks[`link_${locale}`]}
          locale={locale}
        >
          <FontAwesomeIcon icon={faAddressCard} />
          <span>{ContactInformationLinks[`name_${locale}`]}</span>
        </NavLink>

        <NavLink href={ProductsLink[`${locale}`]} locale={locale}>
          <FontAwesomeIcon icon={faStore} />
          <span>{ProductsLink[`name_${locale}`]}</span>
        </NavLink>
        <NavLink href={DownloadLoadBrochuresLink[`link_${locale}`]}>
          <FontAwesomeIcon icon={faDownload} />
          <span>{DownloadLoadBrochuresLink[`name_${locale}`]}</span>
        </NavLink>
        <NavLink href={BuyersGuidsLink[`link_${locale}`]}>
          <FontAwesomeIcon icon={faBookOpen} />
          <span>{BuyersGuidsLink[`name_${locale}`]}</span>
        </NavLink>
        <NavLink href={AskOfferLinks[`link_${locale}`]}>
          <FontAwesomeIcon icon={faCommentDots} />
          <span>{AskOfferLinks[`name_${locale}`]}</span>
        </NavLink>
      </ul>
    </div>
  );
}
